<!-- Back Button -->
<div class="container">
  <div class="pt-lg-4">
    <div class="text-white cursor-pointer d-none d-lg-flex btn-circle-gloss bg-glass" (click)="goBack()">
      <span class="material-icons pe-1">arrow_back_ios_new</span>
    </div>
  </div>
</div>

<!--Point Summary Bar-->
<div class="container">
  <fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'" [backButtonTitle]="'Raffles'"></fgb-points-summary-bar>
</div>

<!--Lotto Details-->
<fgbcl-lotto-details-v2 [lottoId]="id" />
